import { PieChart, Pie, Cell, ResponsiveContainer, Legend, Tooltip } from 'recharts';
import type { SalesPhase } from '../types';

interface PhaseChartProps {
  data: Record<SalesPhase, number>;
}

const phaseLabels: Record<SalesPhase, string> = {
  erstkontakt: 'Erstkontakt',
  qualifikation: 'Qualifikation',
  angebot: 'Angebot',
  verhandlung: 'Verhandlung',
  abschluss: 'Abschluss',
  nachbearbeitung: 'Nachbearbeitung',
};

const COLORS = [
  '#3b82f6', // blue
  '#8b5cf6', // purple
  '#10b981', // green
  '#f59e0b', // amber
  '#ef4444', // red
  '#6b7280', // gray
];

export default function PhaseChart({ data }: PhaseChartProps) {
  const chartData = Object.entries(data)
    .map(([phase, value]) => ({
      name: phaseLabels[phase as SalesPhase] || phase,
      value,
    }))
    .filter((item) => item.value > 0);

  const total = chartData.reduce((sum, item) => sum + item.value, 0);

  if (total === 0) {
    return (
      <div className="card p-6">
        <h3 className="text-lg font-medium text-gray-900 mb-4">Calls by Phase</h3>
        <div className="h-64 flex items-center justify-center text-gray-500">
          Keine Daten verfugbar
        </div>
      </div>
    );
  }

  return (
    <div className="card p-6">
      <h3 className="text-lg font-medium text-gray-900 mb-4">Calls by Phase</h3>
      <div className="h-64">
        <ResponsiveContainer width="100%" height="100%">
          <PieChart>
            <Pie
              data={chartData}
              cx="50%"
              cy="50%"
              innerRadius={60}
              outerRadius={80}
              paddingAngle={2}
              dataKey="value"
            >
              {chartData.map((_, index) => (
                <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
              ))}
            </Pie>
            <Tooltip
              formatter={(value: number) => [`${value} Calls`, '']}
              contentStyle={{
                backgroundColor: 'white',
                border: '1px solid #e5e7eb',
                borderRadius: '8px',
                padding: '8px 12px',
              }}
            />
            <Legend
              layout="vertical"
              align="right"
              verticalAlign="middle"
              formatter={(value) => (
                <span className="text-sm text-gray-600">{value}</span>
              )}
            />
          </PieChart>
        </ResponsiveContainer>
      </div>
      <div className="mt-4 text-center">
        <p className="text-3xl font-bold text-gray-900">{total}</p>
        <p className="text-sm text-gray-500">Gesamt</p>
      </div>
    </div>
  );
}
